// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_access_requests_defaults.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppAccessRequestsDefaultsService } from "./app_access_requests_defaults";
import type { CancelAccessRequestDefaultsRequest } from "./app_access_requests_defaults";
import type { GetAccessRequestDefaultsRequest } from "./app_access_requests_defaults";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AppAccessRequestDefaults } from "./app_access_requests_defaults";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppAccessRequestsDefaultsService
 */
export interface IAppAccessRequestsDefaultsServiceClient {
    /**
     * @generated from protobuf rpc: CreateAppAccessRequestsDefaults
     */
    createAppAccessRequestsDefaults(input: AppAccessRequestDefaults, options?: RpcOptions): UnaryCall<AppAccessRequestDefaults, AppAccessRequestDefaults>;
    /**
     * @generated from protobuf rpc: GetAppAccessRequestsDefaults
     */
    getAppAccessRequestsDefaults(input: GetAccessRequestDefaultsRequest, options?: RpcOptions): UnaryCall<GetAccessRequestDefaultsRequest, AppAccessRequestDefaults>;
    /**
     * @generated from protobuf rpc: CancelAppAccessRequestsDefaults
     */
    cancelAppAccessRequestsDefaults(input: CancelAccessRequestDefaultsRequest, options?: RpcOptions): UnaryCall<CancelAccessRequestDefaultsRequest, AppAccessRequestDefaults>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppAccessRequestsDefaultsService
 */
export class AppAccessRequestsDefaultsServiceClient implements IAppAccessRequestsDefaultsServiceClient, ServiceInfo {
    typeName = AppAccessRequestsDefaultsService.typeName;
    methods = AppAccessRequestsDefaultsService.methods;
    options = AppAccessRequestsDefaultsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: CreateAppAccessRequestsDefaults
     */
    createAppAccessRequestsDefaults(input: AppAccessRequestDefaults, options?: RpcOptions): UnaryCall<AppAccessRequestDefaults, AppAccessRequestDefaults> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppAccessRequestDefaults, AppAccessRequestDefaults>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAppAccessRequestsDefaults
     */
    getAppAccessRequestsDefaults(input: GetAccessRequestDefaultsRequest, options?: RpcOptions): UnaryCall<GetAccessRequestDefaultsRequest, AppAccessRequestDefaults> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccessRequestDefaultsRequest, AppAccessRequestDefaults>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CancelAppAccessRequestsDefaults
     */
    cancelAppAccessRequestsDefaults(input: CancelAccessRequestDefaultsRequest, options?: RpcOptions): UnaryCall<CancelAccessRequestDefaultsRequest, AppAccessRequestDefaults> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<CancelAccessRequestDefaultsRequest, AppAccessRequestDefaults>("unary", this._transport, method, opt, input);
    }
}
